import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, NameInput, SearchIcon } from './styles';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const Name = ({ value, onChange }: Props) => {
  const { t } = useStoreTranslation();

  const handleChange = (e: React.SyntheticEvent) => onChange((e.target as HTMLInputElement).value);

  return (
    <Container>
      <NameInput placeholder={t('hotelsFilters.hotelName.placeHolder')} value={value} onChange={handleChange}>
        <SearchIcon />
      </NameInput>
    </Container>
  );
};

export default Name;
